"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseButton = void 0;
const react_1 = __importStar(require("react"));
const Button_styles_1 = require("./Button.styles");
const ButtonView_type_1 = require("./types/ButtonView.type");
const common_1 = require("../common");
const DesignSystem_1 = require("../DesignSystem");
const helpers_1 = require("../helpers");
const Icon_1 = require("../Icon");
exports.BaseButton = (0, react_1.forwardRef)((_a, ref) => {
    var { className, ui = ButtonView_type_1.BUTTON_VIEW.primary, children, disabled = false, tabIndex, onFocus, onBlur, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, controlHeight, style, iconBefore, iconSize } = _a, rest = __rest(_a, ["className", "ui", "children", "disabled", "tabIndex", "onFocus", "onBlur", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "controlHeight", "style", "iconBefore", "iconSize"]);
    const { isModernUI } = (0, DesignSystem_1.useUI)();
    const iconOnly = (0, react_1.useMemo)(() => Boolean(iconBefore) && !Boolean(children), [children, iconBefore]);
    const buttonIconSize = (0, react_1.useMemo)(() => {
        if (iconSize) {
            return iconSize;
        }
        if (!isModernUI) {
            return Icon_1.ICON_SIZES.m;
        }
        if (controlHeight === common_1.CONTROL_HEIGHT.s) {
            return Icon_1.ICON_SIZES.m;
        }
        return Icon_1.ICON_SIZES.l;
    }, [controlHeight, iconSize, isModernUI]);
    return (react_1.default.createElement(Button_styles_1.StyledButton, Object.assign({ ref: ref, style: style, "data-selector-id": rest['data-selector-id'] || 'button', ui: ui, iconOnly: iconOnly, controlHeight: controlHeight, isDisabled: disabled, tabIndex: disabled ? -1 : tabIndex, onFocus: (e) => {
            if (!disabled) {
                onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
            }
        }, onBlur: (e) => {
            if (!disabled) {
                onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
            }
        }, onClick: (e) => {
            if (!disabled) {
                onClick === null || onClick === void 0 ? void 0 : onClick(e);
            }
        }, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: (e) => {
            if (!disabled) {
                onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
            }
        }, onKeyUp: (e) => {
            if (!disabled) {
                onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(e);
            }
        }, onMouseDown: (e) => {
            if (!disabled) {
                onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
            }
        }, onMouseUp: (e) => {
            if (!disabled) {
                onMouseUp === null || onMouseUp === void 0 ? void 0 : onMouseUp(e);
            }
        }, onKeyPress: (e) => {
            if (!disabled) {
                onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress(e);
            }
        } }, rest, { className: (0, helpers_1.cn)(className, 'vm-Button') }),
        iconBefore ? (react_1.default.createElement(Icon_1.Icon, { "data-selector-id": "icon-before", src: iconBefore, size: buttonIconSize, disabled: disabled })) : null,
        children));
});
//# sourceMappingURL=BaseButton.js.map